var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0053 0.3909H3.31598C1.99183 0.3909 0.914551 1.46818 0.914551 2.79233V8.76922C0.914551 10.0934 1.99183 11.1706 3.31598 11.1706H19.0053C20.3295 11.1706 21.4067 10.0934 21.4067 8.76922V2.79233C21.4067 1.46818 20.3295 0.3909 19.0053 0.3909ZM19.8058 8.76922C19.8058 9.2106 19.4467 9.56969 19.0053 9.56969H3.31598C2.8746 9.56969 2.5155 9.2106 2.5155 8.76922V2.79233C2.5155 2.35095 2.8746 1.99185 3.31598 1.99185H19.0053C19.4467 1.99185 19.8058 2.35095 19.8058 2.79233V8.76922Z",
    fill: "#15466B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72382 4.97986H10.3499C10.792 4.97986 11.1503 5.33824 11.1503 5.78033C11.1503 6.22243 10.792 6.58081 10.3499 6.58081H5.72382C5.28173 6.58081 4.92334 6.22243 4.92334 5.78033C4.92334 5.33824 5.28173 4.97986 5.72382 4.97986Z",
    fill: "#15466B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextOutline);
export default __webpack_public_path__ + "static/media/text-outline.34f786a84f207bfcd6d98949ee28e656.svg";
export { ForwardRef as ReactComponent };